import { Card } from "@design-system/Card/Card";
import { Button } from "@design-system/Button/Button";
import { format } from "date-fns";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { currencyFormatterNoFractions } from "@common/helpers/currency";
import { fromIntToMonetary } from "@common/helpers/monetary";
import classNames from "classnames";
import { BillingHistory } from "@common/types/billing";
import { InvoiceStatus } from "@common/billing";
import { DownloadIcon } from "@icons";
import styles from "./FlatRateBilling.module.scss";

const INVOICE_STATUS_LABEL: Record<InvoiceStatus, string> = {
    [InvoiceStatus.DRAFT]: "Draft",
    [InvoiceStatus.OPEN]: "Open",
    [InvoiceStatus.PAID]: "Paid",
    [InvoiceStatus.VOID]: "Voided",
    [InvoiceStatus.UNCOLLECTIBLE]: "Uncollectible",
};

interface BillingHistoryCardProps {
    billingHistory: BillingHistory;
}

export const BillingHistoryCard: React.FC<BillingHistoryCardProps> = ({
    billingHistory,
}) => (
    <Card className={classNames(styles.card, styles.invoices)}>
        {billingHistory.invoices.map((invoice) => (
            <section
                key={invoice.date.toISOString()}
                className={classNames(styles.section, styles.compact)}
            >
                <strong>{format(invoice.date, fullDateFullYearFormat)}</strong>

                <span className="text-right">
                    {INVOICE_STATUS_LABEL[invoice.status]}
                </span>
                <span className="text-gray-700">
                    {currencyFormatterNoFractions.format(
                        fromIntToMonetary(invoice.totalInCents),
                    )}
                </span>

                {invoice.url ? (
                    <Button
                        variant="primary"
                        size="md"
                        iconOnly
                        aria-label="Download invoice"
                        onClick={() => {
                            if (!invoice.url) {
                                return;
                            }
                            window.open(
                                invoice.url,
                                "_blank",
                                "noopener,noreferrer",
                            );
                        }}
                    >
                        <DownloadIcon />
                    </Button>
                ) : null}
            </section>
        ))}
    </Card>
);
